/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type SbRespInteriorsPhotoCarousel_photos = ReadonlyArray<{
    readonly name: string | null;
    readonly path: string | null;
    readonly " $refType": "SbRespInteriorsPhotoCarousel_photos";
}>;
export type SbRespInteriorsPhotoCarousel_photos$data = SbRespInteriorsPhotoCarousel_photos;
export type SbRespInteriorsPhotoCarousel_photos$key = ReadonlyArray<{
    readonly " $data"?: SbRespInteriorsPhotoCarousel_photos$data;
    readonly " $fragmentRefs": FragmentRefs<"SbRespInteriorsPhotoCarousel_photos">;
}>;



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SbRespInteriorsPhotoCarousel_photos",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "path",
      "storageKey": null
    }
  ],
  "type": "PhotosSearchBrowsePhoto",
  "abstractKey": null
};
(node as any).hash = '123f640fa8808348ab12185fa6929956';
export default node;
